import CryptoJS from 'crypto-js';

const SECRET_KEY = 'winrox11_pwa_secure_2026';

/**
 * Secure Storage Utility for PWA
 * Handles transparent encryption/decryption of sensitive data
 */
export const secureStorage = {
  setItem: (key, value) => {
    try {
      const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
      const encryptedValue = CryptoJS.AES.encrypt(stringValue, SECRET_KEY).toString();
      localStorage.setItem(key, encryptedValue);
    } catch (error) {
      console.error('Error encrypting storage data:', error);
      localStorage.setItem(key, JSON.stringify(value));
    }
  },

  getItem: (key) => {
    try {
      const encryptedValue = localStorage.getItem(key);
      if (!encryptedValue) return null;

      if (encryptedValue.startsWith('{') || encryptedValue.startsWith('[')) {
        return JSON.parse(encryptedValue);
      }

      const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      
      return decryptedData ? JSON.parse(decryptedData) : null;
    } catch (error) {
      console.error('Error decrypting storage data:', error);
      try {
        const val = localStorage.getItem(key);
        return val ? JSON.parse(val) : null;
      } catch {
        return null;
      }
    }
  },

  removeItem: (key) => {
    localStorage.removeItem(key);
  }
};

export const getUser = () => secureStorage.getItem('winrox11_user') || {};
export const setUser = (userData) => secureStorage.setItem('winrox11_user', userData);

export const getToken = () => {
    try {
        const token = localStorage.getItem('winrox11_token');
        if (!token) return null;
        
        // CryptoJS AES ciphertexts always start with "U2FsdGVkX1" (Salted__ in Base64)
        // If it doesn't have this prefix, it's likely a plain JWT or corrupted
        if (!token.startsWith("U2FsdGVkX1")) {
            return (token.length > 10 && token.includes('.')) ? token : null;
        }

        try {
            const bytes = CryptoJS.AES.decrypt(token, SECRET_KEY);
            const decoded = bytes.toString(CryptoJS.enc.Utf8);
            
            if (decoded && /^[\x00-\x7F]*$/.test(decoded)) {
                return decoded;
            }
        } catch (e) {
            // Decryption failed or malformed UTF-8
            return null;
        }
        return null;
    } catch (err) {
        return null;
    }
};

export const setToken = (token) => {
    if (!token) return;
    const encrypted = CryptoJS.AES.encrypt(token, SECRET_KEY).toString();
    localStorage.setItem('winrox11_token', encrypted);
};
